export const THEMES = {
  COUNT: {
    color: 'blue',
    border: 'border-blue-500',
    bg: 'bg-blue-600',
    text: 'text-blue-600',
    light: 'bg-blue-50',
    hover: 'hover:bg-blue-700',
    shadow: 'shadow-blue-200',
  },
  SALE: {
    color: 'green',
    border: 'border-green-500',
    bg: 'bg-green-600',
    text: 'text-green-600',
    light: 'bg-green-50',
    hover: 'hover:bg-green-700',
    shadow: 'shadow-green-200',
  },
  RETURN: {
    color: 'purple',
    border: 'border-purple-500',
    bg: 'bg-purple-600',
    text: 'text-purple-600',
    light: 'bg-purple-50',
    hover: 'hover:bg-purple-700',
    shadow: 'shadow-purple-200',
  },
  SCRAP: {
    color: 'red',
    border: 'border-red-500',
    bg: 'bg-red-600',
    text: 'text-red-600',
    light: 'bg-red-50',
    hover: 'hover:bg-red-700',
    shadow: 'shadow-red-200',
  },
  INTERNAL: {
    color: 'orange',
    border: 'border-orange-500',
    bg: 'bg-orange-500',
    text: 'text-orange-500',
    light: 'bg-orange-50',
    hover: 'hover:bg-orange-600',
    shadow: 'shadow-orange-200',
  },
} as const;

export const getTheme = (mode: keyof typeof THEMES) => {
  return THEMES[mode] || THEMES.COUNT;
};
